(() => {
  const storageKey = 'evo-drawer-navigation-v1';
  const activeClass = 'menu-drawer__menu-item--active';
  const pathKey = (url) => url.pathname.replace(/\/+$/, '') || '/';

  function readPaths() {
    try {
      const paths = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
      return Array.isArray(paths) ? paths.filter((entry) =>
        Array.isArray(entry) && entry.length === 2 &&
        entry.every((value) => typeof value === 'string')
      ).slice(-30) : [];
    } catch (_) {
      return [];
    }
  }

  function updateHighlight() {
    const drawer = document.getElementById('menu-drawer');
    if (!drawer) return;
    const roots = Array.from(drawer.querySelectorAll('[data-evo-parent]'));
    const candidates = roots.filter((root) => root.hasAttribute('data-evo-active-candidate'));
    const saved = readPaths().find((entry) => entry[0] === pathKey(new URL(location.href)));
    const selected = candidates.find((root) => root.dataset.evoParent === saved?.[1]) || candidates[0];
    roots.forEach((root) => {
      const item = root.querySelector('.menu-drawer__menu-item');
      if (item) item.classList.toggle(activeClass, root === selected);
    });
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    const root = link?.closest('#menu-drawer [data-evo-parent]');
    if (!root || link.hasAttribute('download') ||
        (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    const path = pathKey(url);
    const paths = readPaths().filter((entry) => entry[0] !== path);
    paths.push([path, root.dataset.evoParent]);
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(paths.slice(-30)));
    } catch (_) {
      // Storage may be unavailable; Liquid already selects one fallback parent.
    }
  });

  updateHighlight();
  window.addEventListener('pageshow', updateHighlight);
  document.addEventListener('shopify:section:load', updateHighlight);
})();
